import * as THREE from 'https://cdn.skypack.dev/three@0.133.1/build/three.module.js';
import { OrbitControls } from 'https://cdn.skypack.dev/three@0.133.1/examples/jsm/controls/OrbitControls.js';

let camera, scene, renderer, video, sprites = [];
let mouseX = 0, mouseY = 0;

init();
animate();

function init() {
    camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 100);
    camera.position.z = 3;
    scene = new THREE.Scene();

    const container = document.getElementById('webcamBackgroundContainer');

    video = document.getElementById('video');
    const texture = new THREE.VideoTexture(video);
    texture.colorSpace = THREE.SRGBColorSpace;

    const grayscaleShader = {
        uniforms: {
            tDiffuse: { type: "t", value: null }
        },
        vertexShader: `
            varying vec2 vUv;
            void main() {
                vUv = uv;
                gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
            }
        `,
        fragmentShader: `
            uniform sampler2D tDiffuse;
            varying vec2 vUv;
            void main() {
                vec4 color = texture2D(tDiffuse, vUv);
                float gray = dot(color.rgb, vec3(0.299, 0.587, 0.114));
                gl_FragColor = vec4(vec3(gray), color.a);
            }
        `
    };

    const grayscaleMaterial = new THREE.ShaderMaterial({
        uniforms: grayscaleShader.uniforms,
        vertexShader: grayscaleShader.vertexShader,
        fragmentShader: grayscaleShader.fragmentShader
    });
    grayscaleMaterial.uniforms.tDiffuse.value = texture;

    const geometry = new THREE.PlaneGeometry(16, 9);
    geometry.scale(0.5, 0.5, 0.5);
    const material = grayscaleMaterial;

    const count = 512;  // Example values
  
    for (let i = 1, l = count; i <= l; i++) {
        const mesh = new THREE.Mesh(geometry, material);
        mesh.position.set((Math.random() - 0.5) * 50, (Math.random() - 0.5) * 50, (Math.random() - 0.5) * 50);
        mesh.position.normalize().multiplyScalar(100 + (Math.random() * 300));
        const scale = 0.02 + 15 * Math.random();
        mesh.scale.set(scale, scale, 10);
        mesh.rotationSpeed = Math.random() * 0.02;
        mesh.lookAt(camera.position);
        scene.add(mesh);
        sprites.push(mesh);
    }

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x000000, 0);
    document.body.appendChild(renderer.domElement);
    container.appendChild(renderer.domElement);

    window.addEventListener('resize', onWindowResize);
    document.addEventListener('mousemove', onDocumentMouseMove);
    document.addEventListener('touchmove', onDocumentTouchMove);

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const constraints = { video: { width: 1280, height: 720, facingMode: 'user' } };
        navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
            video.srcObject = stream;
            video.play();
        }).catch(function (error) {
            console.error('Unable to access the camera/webcam.', error);
        });
    } else {
        console.error('MediaDevices interface not available.');
    }
}

function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
}

function onDocumentMouseMove(event) {
    updatePosition(event.clientX, event.clientY);
}

function onDocumentTouchMove(event) {
    event.preventDefault();
    if (event.touches.length === 1) {
        updatePosition(event.touches[0].clientX, event.touches[0].clientY);
    }
}

function updatePosition(clientX, clientY) {
    mouseX = (clientX - window.innerWidth / 2) / 100;
    mouseY = -(clientY - window.innerHeight / 2) / 100;
}

function animate() {
    requestAnimationFrame(animate);
    render();
}

function render() {
    const timer = 0.0001 * Date.now();
    camera.position.x += (mouseX - camera.position.x) * 0.05;
    camera.position.y += (-mouseY - camera.position.y) * 0.05;
    camera.lookAt(scene.position);
    for (let i = 0, il = sprites.length; i < il; i++) {
        const sprite = sprites[i];
        sprite.rotation.y += sprite.rotationSpeed;
    }
    renderer.render(scene, camera);
}

